<template>
  <tr v-if="currentResolution" role="row">
    <td class="column-title" role="cell">
      <span>{{ label }}</span>
    </td>
    <td class="column-data flex" role="cell">
      {{ currentResolution }}
    </td>
  </tr>
</template>

<script>
import { computed } from 'vue'

export default {
  props: {
    resolution: String,
    label: String,
  },
  setup(props) {
    const RscResolutions = [
      {id: '_480p', name: '480p'},
      {id: '_720p', name: '720p'},
      {id: '_1080p', name: '1080p'},
      {id: '_4K', name: '4K'}
    ]

    const currentResolution = computed(() => {
      return RscResolutions.find(rscResolutions => rscResolutions.id === props.resolution)?.name || ''
    })

    return {
      currentResolution
    }
  },
}
</script>

<style lang="postcss" scoped>
.column-title {
  font-weight: bold;
  font-size: 1rem;
}

.column-data {
  padding-left: 1.5rem;
}
</style>
